@import '~leaflet/dist/leaflet.css';
@import '~medium-editor/dist/css/medium-editor.css';
@import '~modules/core/client/fonts/fontello/css/tricons-codes.css';

@import '~less/global-variables';
@import './design-tokens';
@import '~less/bootstrap/legacy-classes';
